import React, { useEffect, useState, useCallback, useRef } from 'react';
import {
  Button, Col, Form, Row, Table, Spinner,
  InputGroup, Tooltip, OverlayTrigger,
  DropdownButton, Dropdown
} from 'react-bootstrap';
import axios from '../../api/axios';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import { ArrowLeft, FileEarmarkSpreadsheet, InfoCircle, Search, CloudDownload, X, Clock, ArrowClockwise, CheckCircle, ExclamationTriangle, HourglassSplit, BoxArrowDown, XCircle } from 'react-bootstrap-icons';
import Header from '../../layouts/Header';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import OutletSelect from '../../components/OutletSelect';
import { MAX_DATE_RANGE_DAYS, DATE_RANGE_ERROR_MESSAGE } from '../../constants/dateConstants';

/* ─── helpers ─── */
const safeArray = (val) => (Array.isArray(val) ? val : []);
const fmt = (n) => `₹ ${Number(n || 0).toFixed(2)}`;
const foodTypeMeta = {
  'NON-VEG': { bg: '#dc3545', label: 'Non-Veg' },
  VEGAN: { bg: '#f59e0b', label: 'Vegan' },
  VEG: { bg: '#16a34a', label: 'Veg' },
};
const isLongRange = (start, end) => {
  if (!start || !end) return false;
  const diffDays = (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);
  return diffDays > 90;
};

const VIEW_COMBINED = 'combined';
const VIEW_GROUPED = 'grouped';
const VIEW_CATEGORY = 'category';



/* ─── CSS styles for download manager ─── */
const DM_CSS = `
  :root {
    --or-bg:#f0f2f5; --or-surface:#fff; --or-border:#e2e6ea; --or-text:#1a202c;
    --or-muted:#41505F; --or-accent:#2563eb; --or-accent-light:#eff6ff; --or-accent-dark:#1d4ed8;
    --or-success:#059669; --or-success-light:#ecfdf5; --or-warning:#d97706; --or-warning-light:#fffbeb;
    --or-danger:#dc2626; --or-danger-light:#fef2f2; --or-shadow-lg:0 10px 40px rgba(0,0,0,.12);
    --or-radius:10px; --or-radius-sm:8px; --or-radius-xs:6px;
  }

  .or-dm-fab{
    height:38px; border-radius:var(--or-radius-xs); padding:0 16px;
    background:#fff; border:1.5px solid var(--or-border);
    display:inline-flex; align-items:center; justify-content:center;
    cursor:pointer; transition:all .18s;
    color:var(--or-muted); font-size:13px; font-weight:600; gap:7px;
    white-space:nowrap; box-shadow:0 1px 3px rgba(0,0,0,.08);
  }
  .or-dm-fab:hover{border-color:var(--or-accent);color:var(--or-accent);background:var(--or-accent-light);}
  .or-dm-fab.has-active{border-color:var(--or-accent);color:var(--or-accent);background:var(--or-accent-light);}
  .or-dm-badge{
    background:#dc2626; color:#fff;
    width:18px; height:18px; border-radius:50%;
    margin-left:2px;
    font-size:10px; font-weight:700;
    display:inline-flex; align-items:center; justify-content:center;
  }

  .or-dm-panel{
    position:fixed; top:72px; right:24px; z-index:1049;
    width:580px; max-height:700px;
    background:var(--or-surface);
    border-radius:14px;
    border:1.5px solid var(--or-border);
    box-shadow:0 20px 60px rgba(0,0,0,.15),0 4px 16px rgba(0,0,0,.08);
    display:flex; flex-direction:column;
    overflow:hidden;
    animation:or-dm-in .2s ease;
  }
  @keyframes or-dm-in{from{opacity:0;transform:translateY(-8px) scale(.97);}to{opacity:1;transform:translateY(0) scale(1);}}

  .or-dm-header{
    display:flex; align-items:flex-start; justify-content:space-between;
    padding:20px 22px 18px;
    background:linear-gradient(135deg,#0f172a 0%,#1e3a8a 60%,#1d4ed8 100%);
    color:#fff; flex-shrink:0;
  }
  .or-dm-header-left{flex:1;}
  .or-dm-header-title{display:flex;align-items:center;gap:9px;font-size:15px;font-weight:700;letter-spacing:-.2px;}
  .or-dm-header-sub{font-size:11.5px;opacity:.6;margin-top:3px;}
  .or-dm-stats{display:flex;gap:10px;margin-top:14px;}
  .or-dm-stat{background:rgba(255,255,255,.1);border-radius:8px;padding:9px 16px;text-align:center;border:1px solid rgba(255,255,255,.12);min-width:70px;}
  .or-dm-stat-val{font-size:20px;font-weight:700;color:#fff;line-height:1;}
  .or-dm-stat-lbl{font-size:10px;opacity:.65;margin-top:4px;text-transform:uppercase;letter-spacing:.6px;}
  .or-dm-header-actions{display:flex;align-items:center;gap:6px;flex-shrink:0;padding-top:2px;}
  .or-dm-icon-btn{width:30px;height:30px;border-radius:7px;border:none;background:rgba(255,255,255,.12);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .15s;}
  .or-dm-icon-btn:hover{background:rgba(255,255,255,.25);}

  .or-dm-body{overflow-y:auto;flex:1;padding:14px 16px;display:flex;flex-direction:column;gap:10px;background:#f8fafc;}
  .or-dm-body::-webkit-scrollbar{width:5px;}
  .or-dm-body::-webkit-scrollbar-thumb{background:#d1d5db;border-radius:4px;}

  .or-dm-job{display:flex;align-items:center;gap:12px;padding:14px 16px;border-radius:10px;border:1px solid var(--or-border);background:#fff;transition:box-shadow .15s,border-color .15s;}
  .or-dm-job:hover{box-shadow:0 4px 12px rgba(0,0,0,.09);border-color:#cbd5e1;}
  .or-dm-job-icon{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:17px;}
  .or-dm-job-icon.pending{background:#fef3c7;color:#d97706;}
  .or-dm-job-icon.processing{background:var(--or-accent-light);color:var(--or-accent);}
  .or-dm-job-icon.completed{background:var(--or-success-light);color:var(--or-success);}
  .or-dm-job-icon.failed{background:var(--or-danger-light);color:var(--or-danger);}
  .or-dm-job-info{flex:1;min-width:0;}
  .or-dm-job-name{font-size:13px;font-weight:600;color:var(--or-text);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  .or-dm-job-meta{font-size:11.5px;color:#64748b;margin-top:3px;display:flex;align-items:center;gap:6px;flex-wrap:wrap;}

  .or-pb-wrap{height:4px;background:#e2e8f0;border-radius:3px;margin-top:7px;overflow:hidden;}
  .or-pb{height:100%;border-radius:3px;transition:width .5s ease;}
  .or-pb.pending{background:#fcd34d;width:8%;}
  .or-pb.processing{background:var(--or-accent);width:60%;animation:or-pb-shimmer 1.5s ease-in-out infinite;}
  .or-pb.completed{background:var(--or-success);width:100%;}
  .or-pb.failed{background:var(--or-danger);width:100%;}
  @keyframes or-pb-shimmer{0%,100%{opacity:1;}50%{opacity:.55;}}

  .or-status-pill{font-size:10.5px;font-weight:700;padding:3px 10px;border-radius:20px;white-space:nowrap;flex-shrink:0;}
  .or-status-pill.pending{background:#fef3c7;color:#d97706;}
  .or-status-pill.processing{background:var(--or-accent-light);color:var(--or-accent);}
  .or-status-pill.completed{background:var(--or-success-light);color:var(--or-success);}
  .or-status-pill.failed{background:var(--or-danger-light);color:var(--or-danger);}

  .or-dl-btn{height:32px;padding:0 14px;border-radius:var(--or-radius-xs);border:1.5px solid #a7f3d0;background:var(--or-success-light);color:var(--or-success);font-size:12px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:5px;transition:all .15s;white-space:nowrap;flex-shrink:0;}
  .or-dl-btn:hover{background:var(--or-success);color:#fff;border-color:var(--or-success);}

  .or-del-btn{width:30px;height:30px;border-radius:var(--or-radius-xs);border:1.5px solid #fecaca;background:var(--or-danger-light);color:var(--or-danger);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;transition:all .15s;flex-shrink:0;}
  .or-del-btn:hover:not(:disabled){background:var(--or-danger);color:#fff;border-color:var(--or-danger);}
  .or-del-btn:disabled{opacity:.5;cursor:not-allowed;}

  .or-regen-btn{width:30px;height:30px;border-radius:var(--or-radius-xs);border:1.5px solid #bfdbfe;background:var(--or-accent-light);color:var(--or-accent);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;transition:all .15s;flex-shrink:0;}
  .or-regen-btn:hover:not(:disabled){background:var(--or-accent);color:#fff;border-color:var(--or-accent);}
  .or-regen-btn:disabled{opacity:.5;cursor:not-allowed;}

  .or-dm-footer{padding:12px 18px;border-top:1px solid var(--or-border);flex-shrink:0;display:flex;align-items:center;justify-content:space-between;background:#fff;}
  .or-dm-footer-info{font-size:12px;color:var(--or-muted);display:flex;align-items:center;gap:5px;}
  .or-dm-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:48px 20px;color:var(--or-muted);text-align:center;gap:10px;}

  .or-spin{animation:or-spin .9s linear infinite;display:inline-block;}
  @keyframes or-spin{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}
  .or-pulse{animation:or-pulse 1.5s ease-in-out infinite;}
  @keyframes or-pulse{0%,100%{opacity:1;}50%{opacity:.5;}}

  @media(max-width:768px){
    .or-dm-panel{width:calc(100vw - 32px);left:16px;right:16px;top:72px;}
  }
`;

const ProductSalesReport = () => {
  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem('authToken');

  const [reportData, setReportData] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedOutlets, setSelectedOutlets] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [classType, setClassType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [error, setError] = useState('');
  const [searchText, setSearchText] = useState('');
  const [isTouched, setIsTouched] = useState(false);
  const [viewMode, setViewMode] = useState(VIEW_CATEGORY);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [activeOutletTab, setActiveOutletTab] = useState(0);
  const [categoryCollapsed, setCategoryCollapsed] = useState({});
  const [isMultiOutlet, setIsMultiOutlet] = useState(false);

  /* ── Download manager state ── */
  // ── Download Manager date filters ──
  const [dmStartDate, setDmStartDate] = useState(() => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  });
  const [dmEndDate, setDmEndDate] = useState(() => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  });
  const [dmOpen, setDmOpen] = useState(false);
  const [downloadJobs, setDownloadJobs] = useState([]);
  const [pollingActive, setPollingActive] = useState(false);
  const [jobsLoading, setJobsLoading] = useState(false);
  const pollingRef = useRef(null);
  const dmPanelRef = useRef(null);

  const [deletingJobId, setDeletingJobId] = useState(null);
  const [regeneratingJobId, setRegeneratingJobId] = useState(null);

  const handleDeleteReportRequest = async (jobId) => {
    try {
      setDeletingJobId(jobId);
      const headers = { Authorization: `Bearer ${accessToken}` };
      await axios.delete("report/delete-report-request", {
        headers,
        data: { requestId: jobId },
      });
      toast.success("Request cancelled successfully.", {
        position: "top-right", autoClose: 2000, theme: "light",
      });
      fetchDownloadStatus(true);
    } catch (error) {
      toast.error("Failed to cancel request.", {
        position: "top-right", autoClose: 3000, theme: "light",
      });
    } finally {
      setDeletingJobId(null);
    }
  };

  const handleRegenerateReport = async (jobId) => {
    try {
      setRegeneratingJobId(jobId);
      const headers = { Authorization: `Bearer ${accessToken}` };
      await axios.delete("report/delete-report-storage-path", {
        headers,
        data: { requestId: jobId },
      });
      toast.success("Report regeneration triggered! Please wait…", {
        position: "top-right", autoClose: 2500, theme: "light",
      });
      startPolling();
      fetchDownloadStatus(true);
    } catch (error) {
      toast.error("Failed to trigger regeneration.", {
        position: "top-right", autoClose: 3000, theme: "light",
      });
    } finally {
      setRegeneratingJobId(null);
    }
  };

  useEffect(() => {
    const now = new Date();
    const first = new Date(now.getFullYear(), now.getMonth(), 1);
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    setStartDate(new Date(first.setHours(23, 59, 59, 999)));
    setEndDate(new Date(today.setHours(23, 59, 59, 999)));
    getCategoryList();
    fetchDownloadStatus(true);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dmPanelRef.current && !dmPanelRef.current.contains(e.target)) {
        const fab = document.getElementById("or-dm-fab-psr");
        if (fab && !fab.contains(e.target)) setDmOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => () => stopPolling(), []);

  /* ─── Format date helper ─── */
  const fmtDate = (d) => {
    if (!d) return undefined;
    const dd = new Date(d);
    return `${dd.getFullYear()}-${String(dd.getMonth() + 1).padStart(2, "0")}-${String(dd.getDate()).padStart(2, "0")}`;
  };

  const fmtViewDate = (d) =>
    new Date(d).toLocaleDateString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
    });
  const fmtViewTime = (d) =>
    new Date(d).toLocaleTimeString("en-US", {
      hour: "2-digit", minute: "2-digit", hour12: true,
    });

  const handleDmDateChange = (type, date) => {
    if (type === "start") {
      setDmStartDate(date);
      if (date && dmEndDate) {
        const diffDays = (dmEndDate.getTime() - date.getTime()) / (1000 * 60 * 60 * 24);
        if (diffDays > 30) {
          const clampedEnd = new Date(date);
          clampedEnd.setDate(clampedEnd.getDate() + 30);
          setDmEndDate(clampedEnd);
          fetchDownloadStatus(false, date, clampedEnd);
          return;
        }
      }
      fetchDownloadStatus(false, date, dmEndDate);
    } else {
      setDmEndDate(date);
      fetchDownloadStatus(false, dmStartDate, date);
    }
  };

  /* ═══════════════════════════════════════
     DOWNLOAD MANAGER — POLLING
  ═══════════════════════════════════════ */
  const fetchDownloadStatus = useCallback(
    async (silent = false, overrideStart, overrideEnd) => {
      try {
        if (!silent) setJobsLoading(true);
        const headers = { Authorization: `Bearer ${accessToken}` };

        const today = new Date();
        const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
        const sDate = overrideStart !== undefined ? overrideStart : dmStartDate;
        const eDate = overrideEnd !== undefined ? overrideEnd : dmEndDate;

        const toStr = (d) => {
          if (!d) return todayStr;
          return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
        };

        const res = await axios.get("report/get-report-status/PRODUCT_SALES_REPORT", {
          headers,
          params: { startDate: toStr(sDate), endDate: toStr(eDate) },
        });
        const jobs = res?.data?.data?.reportRequests || res?.data?.reportRequests || [];
        const jobArr = Array.isArray(jobs) ? jobs : [];
        const sorted = [...jobArr].sort((a, b) => {
          const termA = a.status === "COMPLETED" || a.status === "FAILED";
          const termB = b.status === "COMPLETED" || b.status === "FAILED";
          if (termA !== termB) return termA ? 1 : -1;
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
        setDownloadJobs(sorted);
        const allDone = jobArr.every(
          (j) => j.status === "COMPLETED" || j.status === "FAILED"
        );
        if (allDone && jobArr.length > 0) stopPolling();
      } catch (e) {
        console.error("Poll error:", e);
      } finally {
        if (!silent) setJobsLoading(false);
      }
    },
    [accessToken, dmStartDate, dmEndDate]
  );

  const startPolling = useCallback(() => {
    setPollingActive(true);
    fetchDownloadStatus(true);
    if (pollingRef.current) clearInterval(pollingRef.current);
    pollingRef.current = setInterval(() => fetchDownloadStatus(true), 5000);
  }, [fetchDownloadStatus]);

  const stopPolling = useCallback(() => {
    setPollingActive(false);
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }
  }, []);

  /* ─── Job status helpers ─── */
  const getJobCls = (s) => {
    const v = s?.toLowerCase();

    if (v === "completed") return "completed";
    if (v === "failed") return "failed";
    if (v === "no_data") return "no_data";
    if (v === "processing" || v === "in-progress") return "processing";

    return "pending";
  };
  const getJobIcon = (s) => {
    const c = getJobCls(s);
    if (c === "completed") return <CheckCircle size={15} />;
    if (c === "failed") return <ExclamationTriangle size={15} />;
    if (c === "processing")
      return (
        <span className="or-spin">
          <ArrowClockwise size={15} />
        </span>
      );
    return <HourglassSplit size={15} />;
  };
  const getJobLabel = (s) =>
  ({
    completed: "Completed",
    failed: "Failed",
    no_data: "No data found for selected filters",
    processing: "Processing...",
    pending: "Queued",
  }[getJobCls(s)] || "Queued");

  const pendingCount = downloadJobs.filter(
    (j) => getJobCls(j.status) === "pending" || getJobCls(j.status) === "processing"
  ).length;
  const completedCount = downloadJobs.filter(
    (j) => getJobCls(j.status) === "completed"
  ).length;

  /* ─── Download completed file ─── */
  const downloadFile = (job) => {
    const url = job.storagePath;
    if (!url) {
      toast.error("File URL not available.");
      return;
    }
    const link = document.createElement("a");
    link.href = url;
    link.download = `Product_Sales_Report_${job.queryParams?.startDate}_${job.queryParams?.endDate}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  /* ─── Multi-outlet download trigger ─── */
  const triggerMultiOutletDownload = async () => {
    try {
      setDownloadBtnLoading(true);
      const headers = { Authorization: `Bearer ${accessToken}` };
      const outletIds = selectedOutlets.map(o => o.value);
      const categoryIds = selectedCategories.map(c => c.value);
      const qs = new URLSearchParams();
      if (startDate) qs.append('startDate', startDate.toISOString().split('T')[0]);
      if (endDate) qs.append('endDate', endDate.toISOString().split('T')[0]);
      if (classType) qs.append('classType', classType);
      qs.append('isDownload', 'true');

      await axios.post(
        `order/getProductsReportForAdmin/new?${qs.toString()}`,
        { outletIds, categoryIds },
        { headers }
      );

      toast.success("Download job queued! Check the Downloads panel.", {
        position: "top-right", autoClose: 2500, theme: "light",
      });
      setDmOpen(true);
      startPolling();
    } catch (error) {
      const s = error?.response?.status;
      const msg =
        s === 406
          ? error.response?.data?.error?.message || error.response?.data?.error
          : "Failed to queue download job.";
      toast.error(msg, { position: "top-right", autoClose: 3000, theme: "light" });
    } finally {
      setDownloadBtnLoading(false);
    }
  };

  /* ═══════════════════════════════════════════
     EXISTING HELPERS (unchanged)
  ═══════════════════════════════════════════ */

  /* ─── derived data ─── */
  const filteredReportData = safeArray(reportData).map((outletData) => {
    const search = searchText.trim().toLowerCase();
    if (!search) return outletData;
    return {
      ...outletData,
      products: safeArray(outletData.products).filter(p => p.productName?.toLowerCase().includes(search)),
      unSoldProducts: safeArray(outletData.unSoldProducts).filter(p => p.productName?.toLowerCase().includes(search)),
    };
  }).filter(o => safeArray(o.products).length > 0 || safeArray(o.unSoldProducts).length > 0);

  const hasAnyData = filteredReportData.some(
    o => safeArray(o.products).length > 0 || safeArray(o.unSoldProducts).length > 0
  );

  /* ─── Combined view: merge duplicate products across outlets ─── */
  const mergeProducts = (outletDataList, key) =>
    Object.values(
      outletDataList
        .flatMap(o =>
          safeArray(o[key]).map(p => ({ ...p, _outletName: o.outlet?.name }))
        )
        .reduce((acc, p) => {
          const id = p._id || p.productName;
          if (!acc[id]) {
            acc[id] = { ...p, _outletNames: [p._outletName] };
          } else {
            acc[id].totalQuantity = (acc[id].totalQuantity || 0) + (p.totalQuantity || 0);
            acc[id].addonOfferPrice = (acc[id].addonOfferPrice || 0) + (p.addonOfferPrice || 0);
            acc[id].subTotal = (acc[id].subTotal || 0) + (p.subTotal || 0);
            acc[id].finalAfterDiscTotal = (acc[id].finalAfterDiscTotal || 0) + (p.finalAfterDiscTotal || 0);
            if (!acc[id]._outletNames.includes(p._outletName)) {
              acc[id]._outletNames.push(p._outletName);
            }
            acc[id].averageRateOfProduct =
              acc[id].totalQuantity > 0
                ? acc[id].totalTaxable / acc[id].totalQuantity
                : 0;
          }
          return acc;
        }, {})
    );

  const combinedProducts = mergeProducts(filteredReportData, 'products');
  const combinedUnsold = mergeProducts(filteredReportData, 'unSoldProducts');

  /* ─── Category Wise: group all sold/unsold products by category ─── */
  const groupedByCategory = (() => {
    const map = {};
    filteredReportData.flatMap(o =>
      safeArray(o.products).map(p => ({ ...p, _outletName: o.outlet?.name }))
    ).forEach(p => {
      const key = p.categoryName || 'Uncategorized';
      if (!map[key]) map[key] = [];
      map[key].push(p);
    });
    return Object.entries(map).sort(([a], [b]) => a.localeCompare(b));
  })();

  const groupedUnsoldByCategory = (() => {
    const map = {};
    filteredReportData.flatMap(o =>
      safeArray(o.unSoldProducts).map(p => ({ ...p, _outletName: o.outlet?.name }))
    ).forEach(p => {
      const key = p.categoryName || 'Uncategorized';
      if (!map[key]) map[key] = [];
      map[key].push(p);
    });
    return Object.entries(map).sort(([a], [b]) => a.localeCompare(b));
  })();

  /* ─── sort ─── */
  const handleSort = (key) =>
    setSortConfig(prev => ({ key, direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc' }));

  const sortProducts = (products) => {
    if (!sortConfig.key) return safeArray(products);
    return [...safeArray(products)].sort((a, b) => {
      const aVal = a[sortConfig.key] ?? 0;
      const bVal = b[sortConfig.key] ?? 0;
      if (typeof aVal === 'string')
        return sortConfig.direction === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
      return sortConfig.direction === 'asc' ? aVal - bVal : bVal - aVal;
    });
  };

  const SortIcon = ({ colKey }) => (
    sortConfig.key !== colKey
      ? <span style={{ opacity: 0.3, fontSize: 10, marginLeft: 3 }}>⇅</span>
      : <span style={{ fontSize: 10, marginLeft: 3, color: '#0d6efd' }}>{sortConfig.direction === 'asc' ? '↑' : '↓'}</span>
  );

  /* ─── grand totals ─── */
  const grandTotals = (() => {
    const allSold = filteredReportData?.flatMap(o => safeArray(o?.products));
    return {
      qty: allSold?.reduce((s, p) => s + (p?.totalQuantity || 0), 0),
      addon: allSold?.reduce((s, p) => s + (p?.addonOfferPrice || 0), 0),
      actual: allSold?.reduce((s, p) => s + (p?.subTotal || 0), 0),
      disc: allSold?.reduce((s, p) => s + (p?.totalDiscount || 0), 0),
      afterDisc: allSold?.reduce((s, p) => s + (p?.finalAfterDiscTotal || 0), 0),
    };
  })();

  /* ─── api ─── */
  const getCategoryList = async () => {
    try {
      const res = await axios.get('masters/category/get', { headers: { Authorization: `Bearer ${accessToken}` } });
      if (res?.data?.status === true) setCategoryList(res?.data?.data?.categories || []);
    } catch (e) { handleApiError(e); }
  };

  const getProductData = async (sd, ed, outletIds, categoryIds, cType, download, costing) => {
    try {
      setLoading(true);
      const headers = { Authorization: `Bearer ${accessToken}` };
      const qs = new URLSearchParams();
      if (sd) qs.append('startDate', sd.toISOString().split('T')[0]);
      if (ed) qs.append('endDate', ed.toISOString().split('T')[0]);
      if (cType) qs.append('classType', cType);
      if (download) qs.append('isDownload', download);
      if (costing) qs.append('isCosting', costing);

      const res = await axios.post(
        `order/getProductsReportForAdmin/new?${qs.toString()}`,
        { outletIds: safeArray(outletIds), categoryIds: safeArray(categoryIds) },
        { headers, responseType: download ? 'blob' : 'json' }
      );

      if (download) {
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        const names = selectedOutlets.length > 0 ? selectedOutlets.map(o => o.label).join(', ') : 'All Outlets';
        link.download = `${names} Product Sales Report (${sd?.toISOString().split('T')[0]} to ${ed?.toISOString().split('T')[0]}).xlsx`;
        document.body.appendChild(link); link.click();
        document.body.removeChild(link); window.URL.revokeObjectURL(link.href);
        toast.success('Excel file downloaded successfully!', { position: 'top-right', autoClose: 3000, theme: 'light' });
      } else {
        const raw = res?.data?.data;

        // Check if response is a single outlet object or an array
        if (raw && !Array.isArray(raw) && raw.outlet) {
          // Single outlet response: { outlet: {...}, products: [...], unSoldProducts: [...] }
          setReportData([{
            outlet: raw.outlet,
            products: raw.products || [],
            unSoldProducts: raw.unSoldProducts || [],
          }]);
        } else if (Array.isArray(raw)) {
          // Multiple outlets: [{ outlet: {...}, products: [...], unSoldProducts: [...] }, ...]
          setReportData(raw);
        } else {
          setReportData([]);
        }

        setActiveOutletTab(0);
        setCategoryCollapsed({});
      }
    } catch (e) { handleApiError(e); }
    finally { setLoading(false); setDownloadBtnLoading(false); }
  };

  const handleApiError = (e) => {
    let msg = 'An error occurred';
    if (e.response?.status === 406) msg = e.response?.data?.error?.message || e.response?.data?.error;
    else if (e.response?.status === 412) msg = e.response?.data?.data?.message;
    else if (e.response?.status === 500) msg = e.response?.data?.error;
    toast.error(msg, { position: 'top-right', autoClose: 3000, theme: 'light' });
  };

  const handleEndDateChange = (date) => {
    if (startDate && new Date(date) < new Date(startDate)) setError('End date cannot be earlier than start date');
    else { setError(''); setEndDate(date); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setClicked(true); setBtnLoading(true);
    const sd = new Date(new Date(startDate).setHours(23, 59, 59, 999));
    const ed = new Date(new Date(endDate).setHours(23, 59, 59, 999));

    // Determine if multi-outlet
    // const multi = selectedOutlets.length > 1;
    const multi = selectedOutlets.length > 1 || isLongRange(startDate, endDate);
    setIsMultiOutlet(multi);

    if (multi) {
      // Multi-outlet: queue download job
      await triggerMultiOutletDownload();
      setReportData([]); // Clear previous data
    } else {
      // Single outlet: fetch inline
      await getProductData(sd, ed, selectedOutlets.map(o => o.value), selectedCategories.map(c => c.value), classType);
      toast.success('Data Fetched Successfully', { position: 'top-right', autoClose: 3000, theme: 'light' });
    }
    setBtnLoading(false);
  };

  const handleDownloadExcel = (costing) => {
    setDownloadBtnLoading(true);
    const sd = new Date(new Date(startDate).setHours(23, 59, 59, 999));
    const ed = new Date(new Date(endDate).setHours(23, 59, 59, 999));
    getProductData(sd, ed, selectedOutlets.map(o => o.value), selectedCategories.map(c => c.value), classType, true, costing);
  };

  const toggleCategoryCollapse = (key) => {
    setCategoryCollapsed(prev => ({ ...prev, [key]: !prev[key] }));
  };

  /* ─── options ─── */
  const categoryOptions = categoryList.map(c => ({ value: c._id, label: c.name }));
  const classTypeOptions = ['COMBOS', 'DESSERTS', 'EXTRAS', 'FOOD', 'BEVERAGE'].map(v => ({ value: v, label: v }));

  const selectStyles = {
    control: (p, s) => ({
      ...p, borderRadius: 8, fontSize: 13,
      borderColor: s.isFocused ? '#0d6efd' : '#ced4da',
      boxShadow: s.isFocused ? '0 0 0 3px rgba(13,110,253,.15)' : 'none',
      '&:hover': { borderColor: '#0d6efd' },
    }),
    multiValue: (p) => ({ ...p, backgroundColor: '#e7f0ff', borderRadius: 6 }),
    multiValueLabel: (p) => ({ ...p, color: '#0d6efd', fontWeight: 600 }),
    multiValueRemove: (p) => ({ ...p, color: '#0d6efd', ':hover': { backgroundColor: '#0d6efd', color: 'white' } }),
    placeholder: (p) => ({ ...p, color: '#9ca3af', fontSize: 13 }),
    option: (p, s) => ({ ...p, fontSize: 13, backgroundColor: s.isSelected ? '#0d6efd' : s.isFocused ? '#e7f0ff' : 'white' }),
  };

  /* ─── shared styles ─── */
  const tdStyle = { verticalAlign: 'middle', padding: '8px 12px', borderColor: '#f1f5f9' };
  const thStyle = {
    verticalAlign: 'middle', padding: '10px 12px',
    fontSize: 11, fontWeight: 700, letterSpacing: '0.6px',
    textTransform: 'uppercase', color: '#64748b',
    borderBottom: '2px solid #e2e8f0', backgroundColor: '#f8fafc',
    cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap',
  };

  const ThSortable = ({ colKey, align = 'left', children }) => (
    <th style={{ ...thStyle, textAlign: align, width: colKey === 'foodType' ? '10%' : 'auto' }} onClick={() => handleSort(colKey)}>
      {children}<SortIcon colKey={colKey} />
    </th>
  );

  const InfoTip = ({ id, text }) => (
    <OverlayTrigger placement="top" overlay={<Tooltip id={id}>{text}</Tooltip>}>
      <span onClick={e => e.stopPropagation()} style={{ cursor: 'default', marginLeft: 4 }}>
        <InfoCircle size={12} className="text-muted" />
      </span>
    </OverlayTrigger>
  );

  /* ─── product row ─── */
  const renderProductRow = (product, idx, isSold, showOutlet = false) => {
    const meta = foodTypeMeta[product?.foodType] || { bg: '#6c757d', label: product?.foodType };
    return (
      <tr key={`${product._id}-${idx}`} style={{ backgroundColor: isSold ? 'white' : '#fafafa', opacity: isSold ? 1 : 0.7 }}>
        <td style={{ ...tdStyle, color: '#94a3b8', fontSize: 12 }}>{idx + 1}</td>
        <td style={tdStyle}>
          <div style={{ fontWeight: 500, color: '#1e293b', fontSize: 13 }}>{product?.productName || '----'}</div>
          <div style={{ fontSize: 11, marginTop: 2 }}>
            <span style={{ color: '#0d6efd', fontWeight: 600 }}>{product?.categoryName || '----'}</span>
            {showOutlet && product?._outletNames?.length > 0 && (
              <span style={{ color: '#94a3b8', marginLeft: 6, fontSize: 10 }}>
                · {product?._outletNames?.join(', ')}
              </span>
            )}
            {showOutlet && !product?._outletNames && product?._outletName && (
              <span style={{ color: '#94a3b8', marginLeft: 6, fontSize: 10 }}>· {product._outletName}</span>
            )}
          </div>
        </td>
        <td style={tdStyle}>
          <span style={{
            display: 'inline-block', padding: '2px 8px', borderRadius: 20,
            fontSize: 10, fontWeight: 700, letterSpacing: '0.5px',
            backgroundColor: meta.bg + '18', color: meta.bg, border: `1px solid ${meta.bg}40`,
          }}>{meta.label}</span>
        </td>
        <td style={{ ...tdStyle, textAlign: 'right', fontSize: 13 }}>
          {isSold && product?.averageRateOfProduct
            ? `₹ ${Number(product.averageRateOfProduct).toFixed(2)}`
            : <span style={{ color: '#cbd5e1' }}>0.00</span>}
        </td>
        <td style={{ ...tdStyle, textAlign: 'center' }}>
          {isSold
            ? <span style={{ fontWeight: 700, color: '#0d6efd', fontSize: 14 }}>{product?.totalQuantity ?? 0}</span>
            : <span style={{ color: '#94a3b8', fontSize: 12 }}>0</span>}
        </td>
        <td style={{ ...tdStyle, textAlign: 'right', fontSize: 13 }}>
          {isSold ? fmt(product?.subTotal) : <span style={{ color: '#cbd5e1' }}>0.00</span>}
        </td>
        <td style={{ ...tdStyle, textAlign: 'right', fontSize: 13, color: isSold ? '#dc3545' : '#cbd5e1' }}>
          {isSold ? fmt(product?.totalDiscount) : '0.00'}
        </td>
        <td style={{ ...tdStyle, textAlign: 'right', fontSize: 13, color: isSold ? '#16a34a' : '#cbd5e1', fontWeight: isSold ? 600 : 400 }}>
          {isSold ? fmt(product?.finalAfterDiscTotal) : '0.00'}
        </td>
      </tr>
    );
  };

  /* ─── totals row ─── */
  const TotalsRow = ({ label, totals, colSpan = 4 }) => (
    <tr style={{ backgroundColor: '#1e3a5f' }}>
      <td colSpan={colSpan} style={{ ...tdStyle, textAlign: 'right', color: 'white', backgroundColor: '#1e3a5f', fontWeight: 700, fontSize: 11, letterSpacing: '1px', textTransform: 'uppercase' }}>{label}</td>
      <td style={{ ...tdStyle, textAlign: 'center', color: 'white', fontWeight: 700, backgroundColor: '#1e3a5f' }}>{totals.qty}</td>
      <td style={{ ...tdStyle, textAlign: 'right', color: 'white', fontWeight: 600, backgroundColor: '#1e3a5f' }}>{fmt(totals.actual)}</td>
      <td style={{ ...tdStyle, textAlign: 'right', color: '#fca5a5', fontWeight: 600, backgroundColor: '#1e3a5f' }}>{fmt(totals.disc)}</td>
      <td style={{ ...tdStyle, textAlign: 'right', color: '#86efac', fontWeight: 700, backgroundColor: '#1e3a5f' }}>{fmt(totals.afterDisc)}</td>
    </tr>
  );

  /* ─── table head ─── */
  const TableHead = ({ showOutletCol = false }) => (
    <thead>
      <tr>
        <th style={{ ...thStyle, width: 44 }}>#</th>
        <ThSortable colKey="productName">
          {showOutletCol ? 'Product / Category / Outlet' : 'Category & Product'}
        </ThSortable>
        <ThSortable colKey="foodType">Type</ThSortable>
        <ThSortable colKey="averageRateOfProduct" align="right">Avg. Price</ThSortable>
        <ThSortable colKey="totalQuantity" align="center">Qty</ThSortable>
        <th style={{ ...thStyle, textAlign: 'right' }}>
          SubTotal <InfoTip id="at" text="Average Price × Quantity" />
        </th>
        <th style={{ ...thStyle, textAlign: 'right' }}>
          Discount <InfoTip id="disc" text="Before Discount − After Discount Taxable" />
        </th>
        <th style={{ ...thStyle, textAlign: 'right' }}>
          Grandtotal <InfoTip id="adt" text="Sub Total - Total Discount (Grand Total Does Not Include Tax)" />
        </th>
      </tr>
    </thead>
  );

  /* ─── outlet subtotals helper ─── */
  const calcSubTotals = (products) => ({
    qty: safeArray(products)?.reduce((s, p) => s + (p?.totalQuantity || 0), 0),
    addon: safeArray(products)?.reduce((s, p) => s + (p?.addonOfferPrice || 0), 0),
    actual: safeArray(products)?.reduce((s, p) => s + (p?.subTotal || 0), 0),
    disc: safeArray(products)?.reduce((s, p) => s + (p?.totalDiscount || 0), 0),
    afterDisc: safeArray(products)?.reduce((s, p) => s + (p?.finalAfterDiscTotal || 0), 0),
  });

  /* ─── category header row ─── */
  const CategoryHeaderRow = ({ catName, products, collapseKey, isCollapsed, isSold = true }) => {
    const totals = calcSubTotals(products);
    return (
      <tr
        className="psr-special"
        onClick={() => toggleCategoryCollapse(collapseKey)}
        style={{
          backgroundColor: isSold ? '#eef4ff' : '#f8f8f8',
          cursor: 'pointer',
          userSelect: 'none',
        }}
      >
        <td colSpan={5} style={{ ...tdStyle, padding: '9px 12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 11, color: isSold ? '#0d6efd' : '#94a3b8', transition: 'transform 0.15s', display: 'inline-block', transform: isCollapsed ? 'rotate(-90deg)' : 'rotate(0deg)' }}>▼</span>
            <i className={`bi bi-tag${isSold ? '' : ''}`} style={{ fontSize: 12, color: isSold ? '#0d6efd' : '#94a3b8' }}></i>
            <span style={{ fontWeight: 700, fontSize: 12, letterSpacing: '0.4px', color: isSold ? '#0d6efd' : '#94a3b8', textTransform: 'uppercase' }}>
              {catName}
            </span>
            <span style={{
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              minWidth: 20, height: 18, padding: '0 6px',
              borderRadius: 20, fontSize: 9, fontWeight: 700,
              backgroundColor: isSold ? '#0d6efd' : '#94a3b8', color: 'white',
            }}>
              {products.length}
            </span>
          </div>
        </td>
        {isSold ? (
          <>
            <td style={{ ...tdStyle, textAlign: 'right', color: '#64748b', fontSize: 11, fontWeight: 600 }}>{fmt(totals.actual)}</td>
            <td style={{ ...tdStyle, textAlign: 'right', color: '#dc3545', fontSize: 11, fontWeight: 600 }}>{fmt(totals.disc)}</td>
            <td style={{ ...tdStyle, textAlign: 'right', color: '#16a34a', fontSize: 12, fontWeight: 700 }}>{fmt(totals.afterDisc)}</td>
          </>
        ) : (
          <td colSpan={3} style={{ ...tdStyle, color: '#94a3b8', fontSize: 11 }}>No sales in this period</td>
        )}
      </tr>
    );
  };

  const isMultiSelected = selectedOutlets.length > 1;

  /* ════════════════════════════════ JSX ════════════════════════════════ */
  return (
    <React.Fragment>
      <style>{DM_CSS}</style>
      <style>{`
        .psr-filter-box { background:#f8fafc; border:1px solid #e9ecef; border-radius:12px; padding:18px; }
        .psr-table tbody tr:not(.psr-special):hover { background-color:#f0f7ff !important; transition:background 0.1s; }
        .psr-stat-chip { display:inline-flex;align-items:center;gap:6px;background:#e7f0ff;border-radius:8px;padding:4px 12px;font-size:12px;color:#0d6efd;font-weight:600; }
        .view-toggle-btn { border:1.5px solid #e2e8f0; border-radius:8px; padding:6px 16px; font-size:13px; font-weight:600; cursor:pointer; transition:all 0.15s; background:white; color:#64748b; }
        .view-toggle-btn.active { background:#0d6efd; color:white; border-color:#0d6efd; box-shadow:0 2px 8px rgba(13,110,253,.25); }
        .outlet-card-header { background:linear-gradient(90deg,#eef4ff,#f8fafc); padding:10px 16px; border-bottom:1px solid #dbeafe; display:flex; align-items:center; gap:12px; }
        .unsold-section-header { background:#f8f8f8; padding:5px 14px; border-top:1px solid #f1f5f9; font-size:10px; font-weight:700; letter-spacing:.8px; text-transform:uppercase; color:#94a3b8; }
        .outlet-subtotal { background:#f0f7ff !important; }
        .outlet-subtotal td { font-weight:700; }

        /* ── Category rows ── */
        .psr-cat-row-sold:hover td { background:#dbeafe !important; }
        .psr-cat-row-unsold:hover td { background:#f1f5f9 !important; }

        /* ── Outlet tabs ── */
        .outlet-tabs-bar {
          display: flex;
          gap: 0;
          flex-wrap: wrap;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-bottom: none;
          border-radius: 12px 12px 0 0;
          padding: 8px 8px 0 8px;
          overflow-x: auto;
        }
        .outlet-tab-btn {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          padding: 9px 16px 10px 16px;
          border: 1px solid transparent;
          border-bottom: none;
          border-radius: 8px 8px 0 0;
          background: transparent;
          color: #64748b;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.15s;
          white-space: nowrap;
          position: relative;
          margin-bottom: -1px;
        }
        .outlet-tab-btn:hover:not(.active) {
          background: #eef4ff;
          color: #0d6efd;
        }
        .outlet-tab-btn.active {
          background: white;
          color: #0d6efd;
          font-weight: 700;
          border-color: #e2e8f0;
          border-bottom-color: white;
          box-shadow: 0 -2px 0 0 #0d6efd inset;
        }
        .outlet-tab-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 22px;
          height: 18px;
          padding: 0 6px;
          border-radius: 20px;
          font-size: 10px;
          font-weight: 700;
          background: #e2e8f0;
          color: #64748b;
          transition: all 0.15s;
        }
        .outlet-tab-btn.active .outlet-tab-badge {
          background: #0d6efd;
          color: white;
        }
        .outlet-tab-panel {
          border: 1px solid #e2e8f0;
          border-radius: 0 0 12px 12px;
          overflow: hidden;
        }
        /* ── Multi-outlet notice ── */
        .or-multi-notice{margin:12px 0;padding:14px 18px;border-radius:8px;background:#fffbeb;border:1.5px solid #fde68a;display:flex;align-items:flex-start;gap:12px;}
        .or-multi-notice-text{font-size:13px;color:#92400e;line-height:1.6;}
        .or-multi-notice-text strong{color:#78350f;}
      `}</style>

      <Header onSkin={setSkin} />

      <div className={`main main-app p-3 p-lg-4 ${skin === 'dark' ? 'bg-dark text-light' : 'bg-light'}`}>
        <div className="card border-0" style={{ borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,.06),0 4px 16px rgba(0,0,0,.04)', border: '1px solid #e2e8f0' }}>

          {/* ── Page Header ── */}
          <div className="card-header bg-white border-0 py-3 px-4 d-flex justify-content-between align-items-center" style={{ borderRadius: '16px 16px 0 0' }}>
            <div className="d-flex align-items-center gap-3">
              <div style={{ width: 42, height: 42, borderRadius: 10, background: 'linear-gradient(135deg,#0d6efd,#6ea8fe)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className="bi bi-box-seam text-white fs-5"></i>
              </div>
              <div>
                <h5 className="mb-0 fw-bold" style={{ color: '#1e293b', letterSpacing: '-0.3px' }}>PRODUCT SALES REPORT</h5>
                <div style={{ fontSize: 12, color: '#94a3b8' }}>Analyze product performance across outlets</div>
              </div>
            </div>
            <div className="d-flex align-items-center gap-2">
              {/* Download Manager FAB */}
              <button
                id="or-dm-fab-psr"
                className={`or-dm-fab${pendingCount > 0 ? ' has-active' : ''}`}
                onClick={() => setDmOpen((o) => !o)}
                title="Download Manager"
              >
                <CloudDownload size={15} />
                Downloads
                {pendingCount > 0 && (
                  <span className="or-dm-badge or-pulse">{pendingCount}</span>
                )}
                {pendingCount === 0 && completedCount > 0 && (
                  <span className="or-dm-badge" style={{ background: '#059669' }}>
                    {completedCount}
                  </span>
                )}
              </button>
              <Button variant="outline-secondary" size="sm" onClick={() => navigate('/reports/all-reports')}
                className="d-flex align-items-center fw-semibold" style={{ borderRadius: 4, height: 36 }}>
                <ArrowLeft className="me-1" size={14} /> Back to Reports
              </Button>
            </div>
          </div>
          <div style={{ height: 1, background: '#e2e8f0' }} />

          <div className="card-body p-4">
            <Form onSubmit={handleSubmit}>
              {/* ── Filters ── */}
              <div className="psr-filter-box mb-3">
                <Row className="g-3">
                  <Col md={3}>
                    <OutletSelect value={selectedOutlets}
                      onChange={(opts) => setSelectedOutlets(safeArray(opts))}
                      // onChange={(opts) => {
                      //   const arr = safeArray(opts);
                      //   if (arr.length > 1) {
                      //     // toast.info('Multiple outlet selection is temporarily disabled.', {
                      //     //   position: 'top-right', autoClose: 2500, theme: 'light',
                      //     // });
                      //     setSelectedOutlets(arr.slice(0, 1)); // keep only the first
                      //   } else {
                      //     setSelectedOutlets(arr);
                      //   }
                      // }}
                      isMulti={true}
                    />
                  </Col>
                  <Col md={3}>
                    <Form.Label className="fw-semibold" style={{ fontSize: 14, color: '#475569' }}>
                      <i className="bi bi-tags me-1"></i>Category
                    </Form.Label>
                    <Select options={categoryOptions} value={selectedCategories}
                      onChange={(opts) => setSelectedCategories(safeArray(opts))}
                      isMulti isClearable closeMenuOnSelect={false}
                      styles={selectStyles} placeholder="All Categories" />
                  </Col>
                  <Col md={2}>
                    <Form.Label className="fw-semibold" style={{ fontSize: 14, color: '#475569' }}>
                      <i className="bi bi-list-check me-1"></i>Class Type
                    </Form.Label>
                    <Select options={classTypeOptions} value={classTypeOptions.find(o => o.value === classType) || null}
                      onChange={(opt) => setClassType(opt?.value || null)}
                      isClearable styles={selectStyles} placeholder="All Types" />
                  </Col>
                  <Col md={2}>
                    <Form.Label className="fw-semibold" style={{ fontSize: 14, color: '#475569' }}>
                      <i className="bi bi-calendar3 me-1"></i>Start Date
                    </Form.Label>
                    <DatePicker 
                      selected={startDate} 
                      onChange={(date) => {
                        setStartDate(date);
                      }}
                      maxDate={new Date()} 
                      dateFormat="dd-MM-yyyy" className="form-control" />
                  </Col>
                  <Col md={2}>
                    <Form.Label className="fw-semibold" style={{ fontSize: 14, color: '#475569' }}>
                      <i className="bi bi-calendar3 me-1"></i>End Date
                    </Form.Label>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => {
                        handleEndDateChange(date);
                      }}
                      dateFormat="dd-MM-yyyy"
                      minDate={startDate}
                      maxDate={new Date()}
                      className="form-control"
                    />
                    {error && <div className="text-danger" style={{ fontSize: 11, marginTop: 4 }}>{error}</div>}
                  </Col>
                </Row>
              </div>

              {/* ── Actions bar ── */}
              <div className="psr-filter-box mb-4">
                <Row className="g-3 align-items-end">
                  <Col md={3}>
                    <Button variant="primary" size="sm" type="submit" className="w-100 fw-semibold"
                      disabled={!startDate || !endDate || selectedOutlets.length === 0 || btnLoading} style={{ borderRadius: 4, height: 35 }}>
                      {btnLoading
                        ? <><Spinner size="sm" animation="border" className="me-2" />Loading…</>
                        : (isMultiSelected || isLongRange(startDate, endDate))
                          ? <><FileEarmarkSpreadsheet className="me-2" size={14} />Schedule Download</>
                          : <><i className="bi bi-bar-chart-line me-2"></i>Generate Report</>}
                    </Button>
                    {(isMultiSelected || isLongRange(startDate, endDate)) && (
                      <span style={{
                        fontSize: 11, color: '#d97706', fontWeight: 500,
                        display: 'flex', alignItems: 'center', gap: 5, marginTop: 4
                      }}>
                        <ExclamationTriangle size={11} />
                        {isMultiSelected
                          ? `${selectedOutlets.length} outlets — will queue as Excel download`
                          : 'Date range >90 days — will queue as Excel download'}
                      </span>
                    )}
                  </Col>
                  {!isMultiSelected && !isLongRange(startDate, endDate) && (
                    <Col md={2}>
                      <DropdownButton variant="outline-success" className="fw-semibold w-100"
                        title={<>{downloadBtnLoading ? <Spinner size="sm" className="me-2" /> : <FileEarmarkSpreadsheet className="me-2" />}Download Report</>}
                        disabled={!hasAnyData || downloadBtnLoading}>
                        <Dropdown.Item onClick={() => handleDownloadExcel(false)} disabled={downloadBtnLoading}>
                          <FileEarmarkSpreadsheet className="me-2 text-success" />Download without costing
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleDownloadExcel(true)} disabled={downloadBtnLoading}>
                          <FileEarmarkSpreadsheet className="me-2 text-success" />Download with costing
                        </Dropdown.Item>
                      </DropdownButton>
                    </Col>
                  )}
                  {!isMultiSelected && !isLongRange(startDate, endDate) && (
                    <Col md={4}>
                      <InputGroup>
                        <Form.Control type="text" placeholder="Search by product name…" value={searchText}
                          onChange={(e) => { setSearchText(e.target.value); setIsTouched(true); }}
                          style={{ borderRadius: '4px 0 0 4px', fontSize: 13 }} />
                        <Button variant="primary" style={{ zIndex: 0, borderRadius: '0 4px 4px 0' }}
                          onClick={() => setIsTouched(true)} disabled={!searchText.trim()}>
                          <Search size={13} className="me-1" />Search
                        </Button>
                      </InputGroup>
                    </Col>
                  )}

                  {/* stat chips + view toggle — only for single outlet with data */}
                  {!isMultiSelected && hasAnyData && (
                    <>
                      <Col xs={12} md={isMultiSelected ? 12 : 8} className="d-flex gap-2 flex-wrap pt-1">
                        <span className="psr-stat-chip"><i className="bi bi-shop"></i>{filteredReportData.length} Outlet{filteredReportData.length !== 1 ? 's' : ''}</span>
                        <span className="psr-stat-chip"><i className="bi bi-bag-check"></i>{grandTotals.qty} Units Sold</span>
                        <span className="psr-stat-chip" style={{ background: '#dcfce7', color: '#16a34a' }}>
                          <i className="bi bi-currency-rupee"></i>{fmt(grandTotals.afterDisc)} Revenue
                        </span>
                        <span className="psr-stat-chip" style={{ background: '#fee2e2', color: '#dc3545' }}>
                          <i className="bi bi-tag"></i>{fmt(grandTotals.disc)} Discounts
                        </span>
                      </Col>

                      <Col md="auto" className="ms-auto">
                        <div className="d-flex gap-2">
                          <button type="button"
                            className={`view-toggle-btn ${viewMode === VIEW_COMBINED ? 'active' : ''}`}
                            onClick={() => setViewMode(VIEW_COMBINED)}>
                            <i className="bi bi-table me-2"></i>Combined
                          </button>
                          <button type="button"
                            className={`view-toggle-btn ${viewMode === VIEW_CATEGORY ? 'active' : ''}`}
                            onClick={() => setViewMode(VIEW_CATEGORY)}>
                            <i className="bi bi-grid-3x3-gap me-2"></i>Category Wise
                          </button>
                          {/* <button type="button"
                            className={`view-toggle-btn ${viewMode === VIEW_GROUPED ? 'active' : ''}`}
                            onClick={() => setViewMode(VIEW_GROUPED)}>
                            <i className="bi bi-layout-split me-2"></i>Outlet Wise
                          </button> */}
                        </div>
                      </Col>
                    </>
                  )}
                </Row>
              </div>
            </Form>

            {/* ══ MULTI-OUTLET INFO BANNER ══ */}
            {clicked && isMultiOutlet && (
              <div className="or-multi-notice">
                <span style={{ fontSize: 18, flexShrink: 0 }}>📥</span>
                <div className="or-multi-notice-text">
                  <strong>Download queued for {selectedOutlets.length} outlets.</strong>{" "}
                  Your report is being generated in the background. Click the{" "}
                  <strong>Downloads</strong> button in the header to track progress and
                  download once ready. You can navigate freely.
                </div>
              </div>
            )}

            {/* ── Empty state ── */}
            {!clicked ? (
              <div className="d-flex flex-column justify-content-center align-items-center py-5 my-3 rounded-3"
                style={{ background: '#f8fafc', border: '2px dashed #e2e8f0', minHeight: 240 }}>
                <div style={{ width: 64, height: 64, borderRadius: 16, background: '#e7f0ff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
                  <i className="bi bi-clipboard-data text-primary fs-3"></i>
                </div>
                <h6 className="text-muted mb-1">No data to display</h6>
                <p className="text-muted mb-0" style={{ fontSize: 13 }}>Select filters above and click <strong>Generate Report</strong></p>
              </div>

            ) : loading && !isMultiOutlet ? (
              <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2 mb-0 text-muted" style={{ fontSize: 13 }}>Loading product data…</p>
              </div>

            ) : isMultiOutlet ? (
              /* Multi-outlet: show only the info banner (data downloads via manager) */
              !loading && (
                <div className="d-flex flex-column justify-content-center align-items-center py-5 my-3 rounded-3"
                  style={{ background: '#f8fafc', border: '2px dashed #e2e8f0', minHeight: 200 }}>
                  <div style={{ width: 64, height: 64, borderRadius: 16, background: '#e7f0ff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
                    <CloudDownload size={28} className="text-primary" />
                  </div>
                  <h6 className="text-muted mb-1">Report queued for download</h6>
                  <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                    Check the <strong>Downloads</strong> panel for your Excel file.
                  </p>
                </div>
              )

            ) : !hasAnyData ? (
              <div className="text-center py-5" style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 12 }}>
                <i className="bi bi-inbox fs-3 text-muted d-block mb-2"></i>
                <span className="text-muted" style={{ fontSize: 13 }}>No products found for the selected criteria</span>
              </div>

            ) : viewMode === VIEW_COMBINED ? (
              /* ══════════ COMBINED VIEW ══════════ */
              <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                <Table className="mb-0 psr-table" style={{ fontSize: 13 }}>
                  <TableHead showOutletCol={filteredReportData.length > 1} />
                  <tbody>
                    {sortProducts(combinedProducts).map((p, i) =>
                      renderProductRow(p, i, true, filteredReportData.length > 1)
                    )}
                    <TotalsRow label="Grand Total" totals={grandTotals} />

                    {combinedUnsold.length > 0 && (
                      <tr className="psr-special">
                        <td colSpan="8" style={{ padding: '6px 16px', background: '#f8f8f8', fontSize: 10, fontWeight: 700, letterSpacing: '.8px', textTransform: 'uppercase', color: '#94a3b8', borderTop: '2px solid #e2e8f0' }}>
                          <i className="bi bi-slash-circle me-2"></i>Unsold Products ({combinedUnsold.length})
                        </td>
                      </tr>
                    )}
                    {sortProducts(combinedUnsold).map((p, i) =>
                      renderProductRow(p, i, false, filteredReportData.length > 1)
                    )}
                  </tbody>
                </Table>
              </div>

            ) : viewMode === VIEW_CATEGORY ? (
              /* ══════════ CATEGORY WISE VIEW ══════════ */
              <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                <div style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0', padding: '8px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ fontSize: 11, color: '#64748b', fontWeight: 600 }}>
                    {groupedByCategory.length} categor{groupedByCategory.length !== 1 ? 'ies' : 'y'}
                  </span>
                  <div style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
                    <button type="button" onClick={() => {
                      const keys = {};
                      groupedByCategory.forEach(([k]) => { keys[k] = false; });
                      groupedUnsoldByCategory.forEach(([k]) => { keys[`unsold_${k}`] = false; });
                      setCategoryCollapsed(keys);
                    }} style={{ fontSize: 11, padding: '3px 10px', border: '1px solid #e2e8f0', borderRadius: 6, background: 'white', color: '#0d6efd', cursor: 'pointer', fontWeight: 600 }}>
                      <i className="bi bi-arrows-expand me-1"></i>Expand All
                    </button>
                    <button type="button" onClick={() => {
                      const keys = {};
                      groupedByCategory.forEach(([k]) => { keys[k] = true; });
                      groupedUnsoldByCategory.forEach(([k]) => { keys[`unsold_${k}`] = true; });
                      setCategoryCollapsed(keys);
                    }} style={{ fontSize: 11, padding: '3px 10px', border: '1px solid #e2e8f0', borderRadius: 6, background: 'white', color: '#64748b', cursor: 'pointer', fontWeight: 600 }}>
                      <i className="bi bi-arrows-collapse me-1"></i>Collapse All
                    </button>
                  </div>
                </div>
                <Table className="mb-0 psr-table" style={{ fontSize: 13 }}>
                  <TableHead showOutletCol={filteredReportData.length > 1} />
                  <tbody>
                    {groupedByCategory.map(([catName, products]) => {
                      const isCollapsed = categoryCollapsed[catName];
                      return (
                        <React.Fragment key={catName}>
                          <CategoryHeaderRow catName={catName} products={products} collapseKey={catName} isCollapsed={isCollapsed} isSold={true} />
                          {!isCollapsed && sortProducts(products).map((p, i) => renderProductRow(p, i, true, filteredReportData.length > 1))}
                        </React.Fragment>
                      );
                    })}
                    <TotalsRow label="Grand Total" totals={grandTotals} />
                    {groupedUnsoldByCategory.length > 0 && (
                      <tr className="psr-special">
                        <td colSpan="8" style={{ padding: '6px 16px', background: '#f8f8f8', fontSize: 10, fontWeight: 700, letterSpacing: '.8px', textTransform: 'uppercase', color: '#94a3b8', borderTop: '2px solid #e2e8f0' }}>
                          <i className="bi bi-slash-circle me-2"></i>Unsold Products — by Category ({groupedUnsoldByCategory.reduce((s, [, p]) => s + p.length, 0)})
                        </td>
                      </tr>
                    )}
                    {groupedUnsoldByCategory.map(([catName, products]) => {
                      const collapseKey = `unsold_${catName}`;
                      const isCollapsed = categoryCollapsed[collapseKey];
                      return (
                        <React.Fragment key={collapseKey}>
                          <CategoryHeaderRow catName={catName} products={products} collapseKey={collapseKey} isCollapsed={isCollapsed} isSold={false} />
                          {!isCollapsed && sortProducts(products).map((p, i) => renderProductRow(p, i, false, filteredReportData.length > 1))}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

            ) : (
              /* ══════════ GROUPED BY OUTLET VIEW — TABBED ══════════ */
              <div>
                <div className="outlet-tabs-bar">
                  {filteredReportData.map((outletData, idx) => {
                    const unitsSold = safeArray(outletData?.products)?.reduce((s, p) => s + (p?.totalQuantity || 0), 0);
                    const isActive = activeOutletTab === idx;
                    return (
                      <button key={outletData?.outlet?._id} type="button"
                        className={`outlet-tab-btn ${isActive ? 'active' : ''}`}
                        onClick={() => setActiveOutletTab(idx)}>
                        <i className="bi bi-shop" style={{ fontSize: 11 }}></i>
                        {outletData?.outlet?.name}
                        <span className="outlet-tab-badge">{unitsSold}</span>
                      </button>
                    );
                  })}
                </div>
                {(() => {
                  const outletData = filteredReportData[activeOutletTab];
                  if (!outletData) return null;
                  const { outlet, products, unSoldProducts } = outletData;
                  const sold = sortProducts(products);
                  const unsold = sortProducts(unSoldProducts);
                  const sub = calcSubTotals(products);
                  return (
                    <div className="outlet-tab-panel">
                      <div className="outlet-card-header">
                        <div style={{ width: 32, height: 32, borderRadius: 8, background: '#0d6efd22', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <i className="bi bi-shop" style={{ color: '#0d6efd', fontSize: 15 }}></i>
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 700, color: '#0d6efd', fontSize: 14 }}>{outlet?.name}</div>
                          <div style={{ fontSize: 11, color: '#94a3b8' }}>{outlet?.address}</div>
                        </div>
                        <div className="d-flex gap-3 flex-wrap">
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: 18, fontWeight: 800, color: '#0d6efd', lineHeight: 1 }}>{sub.qty}</div>
                            <div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.5px' }}>Units</div>
                          </div>
                          <div style={{ width: 1, background: '#dbeafe' }} />
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: 14, fontWeight: 800, color: '#16a34a', lineHeight: 1 }}>{fmt(sub.afterDisc)}</div>
                            <div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.5px' }}>Revenue</div>
                          </div>
                          <div style={{ width: 1, background: '#dbeafe' }} />
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: 14, fontWeight: 700, color: '#dc3545', lineHeight: 1 }}>{fmt(sub.disc)}</div>
                            <div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.5px' }}>Discount</div>
                          </div>
                          <div style={{ width: 1, background: '#dbeafe' }} />
                          <div className="d-flex gap-2 align-items-center">
                            <span style={{ fontSize: 11, background: '#dbeafe', color: '#1d4ed8', borderRadius: 6, padding: '3px 10px', fontWeight: 600 }}>{safeArray(products).length} sold</span>
                            <span style={{ fontSize: 11, background: '#f1f5f9', color: '#64748b', borderRadius: 6, padding: '3px 10px', fontWeight: 600 }}>{safeArray(unSoldProducts).length} unsold</span>
                          </div>
                        </div>
                      </div>
                      <Table className="mb-0 psr-table" style={{ fontSize: 13 }}>
                        <TableHead />
                        <tbody>
                          {sold.length > 0
                            ? sold.map((p, i) => renderProductRow(p, i, true))
                            : (
                              <tr className="psr-special">
                                <td colSpan="8" className="text-center text-muted py-3 fst-italic" style={{ fontSize: 12, background: '#fafafa' }}>
                                  No sold products in this period
                                </td>
                              </tr>
                            )}
                          {unsold.length > 0 && (
                            <>
                              <tr className="psr-special">
                                <td colSpan="8" className="unsold-section-header">
                                  <i className="bi bi-slash-circle me-2"></i>Unsold Products ({unsold.length})
                                </td>
                              </tr>
                              {unsold.map((p, i) => renderProductRow(p, i, false))}
                            </>
                          )}
                          <tr className="outlet-subtotal psr-special">
                            <td colSpan="4" style={{ ...tdStyle, textAlign: 'right', fontSize: 11, color: '#1d4ed8', textTransform: 'uppercase', letterSpacing: '.5px' }}>Subtotal</td>
                            <td style={{ ...tdStyle, textAlign: 'center', color: '#0d6efd' }}>{sub.qty}</td>
                            <td style={{ ...tdStyle, textAlign: 'right' }}>{fmt(sub.actual)}</td>
                            <td style={{ ...tdStyle, textAlign: 'right', color: '#dc3545' }}>{fmt(sub.disc)}</td>
                            <td style={{ ...tdStyle, textAlign: 'right', color: '#16a34a' }}>{fmt(sub.afterDisc)}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  );
                })()}
                {filteredReportData.length > 1 && (
                  <div style={{ marginTop: 12, borderRadius: 10, overflow: 'hidden', border: '1px solid #1e3a5f' }}>
                    <Table className="mb-0" style={{ fontSize: 13 }}>
                      <tbody>
                        <TotalsRow label="Grand Total — All Outlets" totals={grandTotals} />
                      </tbody>
                    </Table>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════
          FLOATING DOWNLOAD MANAGER PANEL
      ══════════════════════════════════════════ */}
      {dmOpen && (
        <div className="or-dm-panel" ref={dmPanelRef}>
          {/* Header */}
          <div className="or-dm-header">
            <div className="or-dm-header-left">
              <div className="or-dm-header-title">
                <CloudDownload size={17} /> Download Manager
              </div>
              <div className="or-dm-header-sub">Scheduled Excel export jobs</div>

              {/* ── DM Date Filters ── */}
              <div style={{ display: "flex", gap: 10, marginTop: 12, alignItems: "center", flexWrap: "wrap" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
                  <span style={{ fontSize: 9.5, fontWeight: 600, color: "rgba(255,255,255,.55)", textTransform: "uppercase", letterSpacing: ".6px" }}>
                    From
                  </span>
                  <DatePicker
                    selected={dmStartDate}
                    onChange={(date) => handleDmDateChange("start", date)}
                    dateFormat="dd-MM-yyyy"
                    maxDate={new Date()}
                    customInput={
                      <input
                        style={{
                          height: 30, padding: "0 10px", borderRadius: 6,
                          border: "1px solid rgba(255,255,255,.2)",
                          background: "rgba(255,255,255,.1)", color: "#fff",
                          fontSize: 12, fontWeight: 500, cursor: "pointer",
                          outline: "none", width: 112,
                        }}
                      />
                    }
                  />
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
                  <span style={{ fontSize: 9.5, fontWeight: 600, color: "rgba(255,255,255,.55)", textTransform: "uppercase", letterSpacing: ".6px" }}>
                    To
                  </span>
                  <DatePicker
                    selected={dmEndDate}
                    onChange={(date) => handleDmDateChange("end", date)}
                    dateFormat="dd-MM-yyyy"
                    minDate={dmStartDate}
                    maxDate={(() => {
                      if (!dmStartDate) return new Date();
                      const max = new Date(dmStartDate);
                      max.setDate(max.getDate() + 30);
                      const today = new Date();
                      return max > today ? today : max;
                    })()}
                    customInput={
                      <input
                        style={{
                          height: 30, padding: "0 10px", borderRadius: 6,
                          border: "1px solid rgba(255,255,255,.2)",
                          background: "rgba(255,255,255,.1)", color: "#fff",
                          fontSize: 12, fontWeight: 500, cursor: "pointer",
                          outline: "none", width: 112,
                        }}
                      />
                    }
                  />
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
                  <span style={{ fontSize: 9.5, color: "transparent" }}>–</span>
                  <button
                    style={{
                      height: 30, padding: "0 12px", borderRadius: 6,
                      border: "1px solid rgba(255,255,255,.25)",
                      background: "rgba(255,255,255,.15)", color: "#fff",
                      fontSize: 11.5, fontWeight: 600, cursor: "pointer",
                      display: "inline-flex", alignItems: "center", gap: 5,
                    }}
                    onClick={() => fetchDownloadStatus(false)}
                    disabled={jobsLoading}
                  >
                    <Search size={11} /> Apply
                  </button>
                </div>
                <span style={{ fontSize: 10, color: "rgba(255,255,255,.45)", alignSelf: "flex-end", marginBottom: 3 }}>
                  Max 30-day range
                </span>
              </div>

              <div className="or-dm-stats">
                <div className="or-dm-stat">
                  <div className="or-dm-stat-val">{downloadJobs.length}</div>
                  <div className="or-dm-stat-lbl">Total</div>
                </div>
                <div className="or-dm-stat">
                  <div className="or-dm-stat-val">{pendingCount}</div>
                  <div className="or-dm-stat-lbl">In Progress</div>
                </div>
                <div className="or-dm-stat">
                  <div className="or-dm-stat-val">{completedCount}</div>
                  <div className="or-dm-stat-lbl">Ready</div>
                </div>
                <div className="or-dm-stat">
                  <div className="or-dm-stat-val">
                    {downloadJobs.filter(j => getJobCls(j.status) === 'failed').length}
                  </div>
                  <div className="or-dm-stat-lbl">Failed</div>
                </div>
              </div>
            </div>
            <div className="or-dm-header-actions">
              {pollingActive && (
                <span style={{ fontSize: 11, color: "rgba(255,255,255,.65)", display: "flex", alignItems: "center", gap: 4, marginRight: 4 }}>
                  <span className="or-spin"><ArrowClockwise size={11} /></span> Live
                </span>
              )}
              <button
                className="or-dm-icon-btn"
                onClick={() => { setJobsLoading(true); fetchDownloadStatus().finally(() => setJobsLoading(false)); }}
                title="Refresh"
                disabled={jobsLoading}
              >
                {jobsLoading
                  ? <Spinner size="sm" animation="border" style={{ width: 12, height: 12 }} />
                  : <ArrowClockwise size={13} />}
              </button>
              <button className="or-dm-icon-btn" onClick={() => setDmOpen(false)} title="Close">
                <X size={14} />
              </button>
            </div>
          </div>

          {/* Job list */}
          <div className="or-dm-body">
            {downloadJobs.length === 0 ? (
              <div className="or-dm-empty">
                <CloudDownload size={40} style={{ opacity: 0.2 }} />
                <div style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>No download jobs yet</div>
                <div style={{ fontSize: 12.5, color: '#9ca3af', maxWidth: 280 }}>
                  Select multiple outlets and click <strong>Schedule Download</strong> to queue a job.
                </div>
              </div>
            ) : (
              downloadJobs.map((job, idx) => {
                const cls = getJobCls(job.status);
                const qp = job.queryParams || {};
                const outlets = job.requestBody?.outletIds || [];
                return (
                  <div key={job._id || idx} className="or-dm-job">
                    <div className={`or-dm-job-icon ${cls}`}>
                      {getJobIcon(job.status)}
                    </div>
                    <div className="or-dm-job-info">
                      <div className="or-dm-job-name">
                        Product Sales Report — {qp.startDate || '?'} → {qp.endDate || '?'}
                      </div>
                      <div className="or-dm-job-meta">
                        <span style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                          <Clock size={10} /> {fmtViewDate(job.createdAt)} {fmtViewTime(job.createdAt)}
                        </span>
                        <span>·</span>
                        <span>{outlets.length} outlet{outlets.length !== 1 ? 's' : ''}</span>
                        {job.errorMessage && (
                          <span style={{ color: 'var(--or-danger)' }}>· {job.errorMessage}</span>
                        )}
                      </div>
                      <div className="or-pb-wrap">
                        <div className={`or-pb ${cls}`} />
                      </div>
                    </div>
                    <span className={`or-status-pill ${cls}`}>{getJobLabel(job.status)}</span>
                    {cls === 'completed' && job.storagePath && (
                      <button className="or-dl-btn" onClick={() => downloadFile(job)}>
                        <BoxArrowDown size={12} /> Download
                      </button>
                    )}
                    {cls === 'completed' && (
                      <button
                        className="or-regen-btn"
                        title="Regenerate this report"
                        disabled={regeneratingJobId === job._id}
                        onClick={() => handleRegenerateReport(job._id)}
                      >
                        {regeneratingJobId === job._id
                          ? <Spinner animation="border" size="sm" style={{ width: 12, height: 12 }} />
                          : <ArrowClockwise size={14} />}
                      </button>
                    )}
                    {/* {cls !== 'completed' && ( */}
                    <button
                      className="or-del-btn"
                      title="Cancel this request"
                      disabled={deletingJobId === job._id}
                      onClick={() => handleDeleteReportRequest(job._id)}
                    >
                      {deletingJobId === job._id
                        ? <Spinner animation="border" size="sm" style={{ width: 12, height: 12 }} />
                        : <XCircle size={14} />}
                    </button>
                    {/* )} */}
                  </div>
                );
              })
            )}
          </div>

          {/* Footer */}
          <div className="or-dm-footer">
            <span className="or-dm-footer-info">
              {pollingActive ? (
                <>
                  <span className="or-spin" style={{ display: 'inline-flex' }}>
                    <ArrowClockwise size={12} />
                  </span>
                  Auto-refreshing every 5s
                </>
              ) : (
                ''
              )}
            </span>
            <button
              style={{
                height: 30, padding: '0 14px', borderRadius: 6,
                border: '1.5px solid #e2e6ea', background: '#fff',
                fontSize: 12, fontWeight: 500, color: 'var(--or-muted)', cursor: 'pointer',
                display: 'inline-flex', alignItems: 'center', gap: 5,
                opacity: pollingActive ? 0.5 : 1,
              }}
              onClick={startPolling}
              disabled={pollingActive}
            >
              <ArrowClockwise size={11} /> Refresh
            </button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default ProductSalesReport;